import { Grid } from '@mui/material';
import RichText from '../index';
import { MarkdownTowColumn } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';

const LEFT_SIZE_TO_COLS: Record<string, number> = {
  '30': 3,
  '40': 4,
  '50': 5,
  '60': 6,
  '70': 7,
};

const TwoColumns = ({
  leftColumn,
  rightColumn,
  leftSize,
}: DeepNullToUndefined<MarkdownTowColumn>) => {
  const leftCols = LEFT_SIZE_TO_COLS[leftSize ?? '50'] ?? 5;
  const rightCols = 10 - leftCols;

  return (
    <Grid container columns={10} spacing={4} sx={{ mb: 2 }}>
      <Grid size={{ xs: 10, md: leftCols }}>
        <RichText>{leftColumn}</RichText>
      </Grid>
      <Grid size={{ xs: 10, md: rightCols }}>
        <RichText>{rightColumn}</RichText>
      </Grid>
    </Grid>
  );
};
export default TwoColumns;
